import { ChevronRight } from 'lucide-react';

const Card = ({ icon: Icon, iconClassName, badge, badgeClassName, title, description, cta, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="group flex w-full flex-col rounded-xl border border-gray-200 bg-white p-4 text-left transition-colors hover:border-secondary-300 hover:bg-secondary-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
  >
    <div className="flex items-start justify-between gap-3">
      <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${iconClassName}`}>
        <Icon size={18} strokeWidth={2.2} />
      </span>

      {badge && (
        <span className={`shrink-0 rounded-full px-2.5 py-1 text-[11px] font-semibold ${badgeClassName}`}>{badge}</span>
      )}
    </div>

    <p className="mt-3 text-[15px] font-bold text-secondary-900">{title}</p>

    <p className="mt-1 flex-1 text-xs leading-relaxed text-secondary-500">{description}</p>

    <div className="mt-3 flex w-full items-center justify-between border-t border-gray-100 pt-3">
      <span className="text-[13px] font-semibold text-secondary-900">{cta}</span>

      <ChevronRight size={16} strokeWidth={2.5} className="shrink-0 text-secondary-300 transition-colors group-hover:text-secondary-500" />
    </div>
  </button>
);

export default Card;
